import React, { useState, useMemo, useEffect } from 'react'
import axios from 'axios';

// import { useNavigate } from 'react-router-dom';
import { MachinetypeColumns } from '../components/machinetype_columns'
import MainLayout from '../layout/MainLayout';
import BasicTable from '../components/BasicTable'
import KnittingmachinetypeNew from '../new_pages/KnittingmachinetypeNew';
import useDeleteWithConfirmation from '../components/useDeleteWithConfirmation';
import DeleteConfirmation from '../components/DeleteConfirmation';
import { formatTimestampNow } from '../utils/functions';
import { convertCommaToDotForFloatFields, setDefaultForEmptyNumberFields, handleFocus, handleBlur, validateField } from '../utils/functions';
import IncorrectInputModalModal from '../components/IncorrectInputModal'; // Importiere die Modal-Komponente zur Ausgabe bei Fehleingaben vom User
import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/ChangeInputArea.css'
import '../components/PopupDatasheet.css'


function KnittingmachinetypePage() {

  // const navigate = useNavigate();
  const access_token = window.localStorage.getItem('access_token');

  const [machinetypes, setMachinetypes] = useState([]);
  const [manufacturerOptions, setManufacturerOptions] = useState([]); // Zustand für Hersteller
  const [departmentOptions, setDepartmentOptions] = useState([]); // Zustand für Maßeinheiten der Fadenspannung
  const [institutionOptions, setInstitutionOptions] = useState([]);

  const [lengthUnitOptions, setLengthUnitOptions] = useState([]); // Zustand für die Längenmaße max_workingwidth
  const [distanceUnitOptions, setDistanceUnitOptions] = useState([]); // Zustand für die Längenmaße distance_needlebeds

  const [imageOptions, setImageOptions] = useState([]); // Zustand für die Maschinetypebilder
  const [datasheetOptions, setDatasheetOptions] = useState([]); // Zustand für die Datenblätter

  const [popupImageUrl, setPopupImageUrl] = useState('');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false); // für Popup Neuer Datensatz

  const [imageUrl, setImageUrl] = useState(null);
  const [copiedData, setCopiedData] = useState(null); // Zustand für kopierte Daten
  const [clickedAnyIcon, setClickedAnyIcon] = useState(false); // Zustandsvariable, um zu überprüfen, welches Symbol geklickt wurde

  const [newSelectedRowID, setNewSelectedRowID] = useState(null);
  
  const [currentInstitutionName, setCurrentInstitutionName] = useState('');
  const [errors, setErrors] = useState({}); // Zustand für Fehler pro Feld
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false); // Zustand für die Anzeige des Modals

  const id_institution = parseInt(window.localStorage.getItem('id_institution'), 10) || 0;
  const id_role = window.localStorage.getItem('id_role');
  // const warningThreshold = window.localStorage.getItem("warning_threshold");
  
  const can_create_machinetype = JSON.parse(window.localStorage.getItem('can_create_machinetype'));
  const can_update_machinetype = JSON.parse(window.localStorage.getItem('can_update_machinetype'));
  const can_delete_machinetype = JSON.parse(window.localStorage.getItem('can_delete_machinetype'));


  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState({
    id_machinetype: '',
    machinetype_name: '',
    manufacturer_name: '',
    institution_name: '',
    department_name: '',
    fineness: '',
    needletype: '',
    max_workingwidth: '',
    unit_max_workingwidth_name: '',
    max_yarncarrier: '',
    knittingsystems: '',
    pulloff_system: '',
    clampingcutting_device: '',
    distance_needlebeds: '',
    unit_distance_needlebeds_name: '',
    datasheet: '',
    filename: '',
    machinetype_others: '',
    machinetype_all_can_read: false, // checkbox mit boolean-Wert initialisieren
    timestamp: '',
  });


  // Funktion zum Leeren der Eingabefelder
  const clearFields = () => {
    setPost({
      // machinetype:
      id_machinetype: '',
      machinetype_name: '',
      manufacturer_name: '',
      institution_name: '',
      department_name: '',
      fineness: '',
      needletype: '',
      max_workingwidth: '',
      unit_max_workingwidth_name: '',
      max_yarncarrier: '',
      knittingsystems: '',
      pulloff_system: '',
      clampingcutting_device: '',
      distance_needlebeds: '',
      unit_distance_needlebeds_name: '',
      datasheet: '',
      filename: '',
      machinetype_others: '',
      machinetype_all_can_read: false, // checkbox mit boolean-Wert initialisieren
      timestamp: '',      
    });
    setErrors({}); // Fehlerzustaende zurücksetzen
  };


  // wird beim Rendern der Komponente ausgeführt
  // useEffect wird bei jedem neuen Laden der Seite ausgeführt
  useEffect(() => {
    fetchMachinetypes();
    fetchManufacturerOptions();
    fetchDepartmentOptions();
    fetchInstitutionOptions();
    fetchUnitOptions('length_dimension_unit', setLengthUnitOptions);
    fetchUnitOptions('distance_unit', setDistanceUnitOptions);
    fetchMachinetypeDatasheetOptions();
    fetchMachinetypeImageOptions();
  }, []);
  

  /*useEffect(() => {
    const checkTokenExpiry = () => {
      console.log("Initializing token expiry check...");

      const expiresAt = window.localStorage.getItem("expires_at");
      if (!expiresAt) return;

      const expiryDate = new Date(expiresAt);
      const now = new Date();
      const timeLeft = expiryDate - now;

      if (timeLeft <= 0) {
        logoutUser();
      } else if (timeLeft <= parseInt(warningThreshold, 10)) { // Warnschwelle von 1 Minuten
        // Zeige Warnung
        showExpiryWarning();
      }        
    };

    const logoutUser = () => {
      console.log("Logging out user due to token expiry.");
      window.localStorage.clear(); // Bereinige gespeicherte Daten
      navigate('/'); // Weiterleitung zur Login-Seite
      
    };
  
    const showExpiryWarning = () => {
      console.log("Warning out user due to token expiry.");
      if (!window.localStorage.getItem("warned_about_expiry")) {
        alert("Ihre Sitzung läuft bald ab. Bitte speichern Sie Ihre Arbeit.");
        window.localStorage.setItem("warned_about_expiry", true); // Verhindert wiederholte Warnungen
      }
    };
   

    // Überwachung alle 5 Sekunden
    const intervalId = setInterval(checkTokenExpiry, 5 * 1000); //5 Sekunden
  
    return () => clearInterval(intervalId); // Cleanup bei unmount
  }, [navigate]); */
  

  // Anzeige der Eingabefelder unter der Tabelle zum Aendern
  const fields = [
    { name: 'machinetype_name', label: 'Bezeichnung Machinentyp', type: 'text', validate: { required: true} },
    { name: 'manufacturer_name', label: 'Hersteller', type: 'select' },
    { name: 'department_name', label: 'Bereich', type: 'select' },
    { name: 'fineness', label: 'Maschinenfeinheit', type: 'text' },
    { name: 'needletype', label: 'Nadeltyp', type: 'text' },
    { name: 'max_workingwidth', label: 'max. Arbeitsbreite', type: 'text', unit: 'unit_max_workingwidth_name', validate: { integer: true} },
    { name: 'max_yarncarrier', label: 'max. Anzahl Fadenführer', type: 'text', validate: { integer: true} },
    { name: 'knittingsystems', label: 'Anzahl Stricksysteme', type: 'text', validate: { integer: true} },
    { name: 'pulloff_system', label: 'Abzugssystem', type: 'text' },
    { name: 'clampingcutting_device', label: 'Klemm- & Schneidvorrichtung', type: 'text' },
    { name: 'distance_needlebeds', label: 'Abstand zwischen Nadelbetten', type: 'text', unit: 'unit_distance_needlebeds_name', validate: { float: true} },
    { name: 'datasheet', label: 'Datenblatt', type: 'select' },
    { name: 'datasheet_buttons', label: '', type: 'datasheet_button_group' },
    { name: 'filename', label: 'Bild', type: 'select' },
    { name: 'picture_buttons', label: '', type: 'picture_button_group' },
    { name: 'machinetype_others', label: 'Sonstige', type: 'textarea' },
    { name: 'machinetype_all_can_read', label: 'Freigabe für alle Institutionen', type: 'checkbox' },
  ];


  // Funktion, um Benutzereingaben in Formularfeldern zu verarbeiten
  const handleInput = (event) => {
    const { name, value, type, checked } = event.target;
    setPost({ ...post, [name]: type === 'checkbox' ? checked : value });
  }

  // Funktion zum Einfügen der Tabellen-Daten
  const fetchMachinetypes = async () => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`, // Korrekte Übergabe des Tokens
          'idInstitution': id_institution, 
          'idRole': id_role,         
        }
      };  
      
      const response = await axios.get(`${url_root}/get_all_knit_machinetype_to_role_institution_and_readable_ext`, param);
      // setMachinetypes setzt machinetypes 
      // das wird damit festgelegt: const [machinetypes, setMachinetypes] = useState([]);
      // ähnlich wie getter-setter
      setMachinetypes(response.data);
      return response.data.knit_machinetype || [];
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };


  // Funktionen für dropdown-Listen  
  // Funktion zum Abrufen aller FunktionsGarnBilder zu Institution 
  const fetchMachinetypeImageOptions = async (f_institution_name) => {    
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`, 
          'institutionName': f_institution_name,
          'idInstitution': id_institution
        }
      };
      
      const response = await axios.get(`${url_root}/get_machinetype_images_from_directory_and_institution`, param);
           
      setImageOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der picture options:', error);
    }
  };

  // Funktionen für dropdown-Listen
  // Funktion zum Abrufen aller FunktionsGarnBilder zu Institution 
  const fetchMachinetypeDatasheetOptions = async (f_institution_name) => {    
    try {     
      const param = {        
        headers: {
          'Authorization': `Bearer ${access_token}`, // Korrekte Übergabe des Tokens
          'institutionName': f_institution_name,
          'idInstitution': id_institution
        }
      };
      const response = await axios.get(`${url_root}/get_machinetype_datasheets_from_directory_and_institution`, param);
      
      setDatasheetOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der picture options:', error);
    }
  };


  // Funktion zum Abrufen der Hersteller-Daten
  const fetchManufacturerOptions = async () => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}` // Korrekte Übergabe des Tokens
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_manufacturer`, param);
      setManufacturerOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der manufacturer options:', error);
    }
  };

  // Funktion zum Abrufen der Bereichs-Daten
  const fetchDepartmentOptions = async (institutionName) => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`, // Korrekte Uebergabe des Tokens
          'idInstitution': id_institution, 
          'institutionName': institutionName
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_department_to_institution_name`, param);
      setDepartmentOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der departmentOptions:', error);
    }
  };


  // Funktion zum Abrufen und Ermitteln der Masseinheiten nach unit_type
  const fetchUnitOptions = async (unitType, setUnitOptions) => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'unitType': unitType          
        }
      };     
      const response = await axios.get(`${url_root}/get_all_knit_unit_to_type`, param);      
      setUnitOptions(response.data);
    } catch (error) {
      console.error(`Fehler beim Abrufen der ${unitType}UnitOptions:`, error);
    }
  };


  // Funktion zum Abrufen der Institutionen-Daten
  const fetchInstitutionOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_institution`, param);
      setInstitutionOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der institution options:', error);
    }
  };
   

  // Vermeidung von Zugriff auf Eigenschaften von null oder leeres Array
  const knitMachinetypeExtArray = machinetypes && machinetypes.knit_machinetype; 
  // Verwende das knitYarnExtArray als Daten für die Tabelle
  const data = useMemo(() => knitMachinetypeExtArray || [], [knitMachinetypeExtArray]);

  // Definiere den Accessor für die BasicTable
  const accessor = 'id_machinetype';


  // Funktion zum Anzeigen des Bildes bei Klick auf eine Zeile in der Tabelle, wird von der BasicTable aufgerufen
  // und bei Aenderungen eines Datensatzes
  const showImage = async (imageName, machinetypeName, institutionName) => {  
    try {   
      const param = {
        headers: {
          'imageName': imageName,
          'institutionName': institutionName,
          'pageType' : 'machinetype',
          'Authorization': `Bearer ${access_token}`      
        },
        responseType: 'blob' // Setzt den Antworttyp auf Blob
      };     
      const response = await axios.get(`${url_root}/show_image_from_server`, param);
      const imageBlob = response.data;

      const imageObjectURL = URL.createObjectURL(imageBlob); // Blob in eine URL konvertieren

      setImageUrl(imageObjectURL); // URL in den State setzen

    } catch (error) {
      console.error('Institution ID konnte nicht abgerufen werden.');
    }
  }; 


  // Funktion zur Anzeige des Datenblatts im Popup-Fenster
  const showDatasheet = async (s_machinetypeId) => {
    try {
      const selectedRowData = data.find(row => row.id_machinetype === s_machinetypeId);
      if (selectedRowData) {
        const selectedInstitutionName = selectedRowData.institution_name;
        const datasheetName = selectedRowData.datasheet;   
        
        const param = {
          headers: {
            'datasheetName': datasheetName,
            'institutionName': selectedInstitutionName,
            'pageType' : 'machinetype',
            'Authorization': `Bearer ${access_token}`
          },
          responseType: 'blob' // Setzt den Antworttyp auf Blob
        }; 

        const response = await axios.get(`${url_root}/show_datasheet_from_server`, param);
        const datasheetBlob = response.data;
      
        const datasheetObjectURL = URL.createObjectURL(datasheetBlob); // Blob in eine URL konvertieren

        setPopupImageUrl(datasheetObjectURL);
        clearFields();
        setClickedAnyIcon(true); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
        setIsPopupOpen(true);        
      }
    } catch (error) {
      console.error('Machinetype ID konnte nicht abgerufen werden.'); 
    }
  };


  // zum Schließen des Popups der Datenblätter
  const closePopup = () => {
    setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsPopupOpen(false);
  };


  // Funktion zur Übertragung des Datensatzes in die Eingabefelder zum Ändern
  const handleButtonChange = (id) => {
    if (!id) {
      return;
    }
   
    // Fehler zuruecksetzen, falls vom vorigen Datensatz noch vorhanden
    setErrors({});
    
    // Datensatz der übergebenen id_machinetype ermitteln
    const changeMachinetypeData = data.find(row => row.id_machinetype === id);
    
    // Wenn kein Datensatz gefunden wird, abbrechen
    if (!changeMachinetypeData) {
      return;
    }

    // Aktuellen Zeitstempel abrufen und formatieren
    const timestamp = formatTimestampNow();

    setPost({
      id_machinetype: changeMachinetypeData.id_machinetype,
      machinetype_name: changeMachinetypeData.machinetype_name || '',
      manufacturer_name: changeMachinetypeData.manufacturer_name || '',
      institution_name: changeMachinetypeData.institution_name || '',
      department_name: changeMachinetypeData.department_name || '',
      fineness: changeMachinetypeData.fineness || '',
      needletype: changeMachinetypeData.needletype || '',
      max_workingwidth: changeMachinetypeData.max_workingwidth,
      unit_max_workingwidth_name: changeMachinetypeData.unit_max_workingwidth_name || '',
      max_yarncarrier: changeMachinetypeData.max_yarncarrier,  
      knittingsystems: changeMachinetypeData.knittingsystems || '',
      pulloff_system: changeMachinetypeData.pulloff_system || '',
      clampingcutting_device: changeMachinetypeData.clampingcutting_device || '',
      distance_needlebeds: changeMachinetypeData.distance_needlebeds,
      unit_distance_needlebeds_name: changeMachinetypeData.unit_distance_needlebeds_name || '',
      datasheet: changeMachinetypeData.datasheet || '',
      filename: changeMachinetypeData.filename || '',
      machinetype_others: changeMachinetypeData.machinetype_others || '',
      machinetype_all_can_read: changeMachinetypeData.machinetype_all_can_read || false,
      //timestamp: timestamp, // aktueller timestamp
      timestamp: changeMachinetypeData.timestamp || formatTimestampNow(),
    })
    setCurrentInstitutionName(changeMachinetypeData.institution_name) //institution, die der angewaehlte Datensatz hat
  };


  // Funktion zum Ändern des Datensatzes
  const handleSave = async (id) => {
    try {
      if (id === "" || id === undefined) {
        setErrorMessage("Bitte wählen Sie einen Maschinentyp zum Ändern aus oder legen Sie mit NEU einen neuen Maschinentyp an.");
        setShowErrorModal(true);
        return;
      }

      // Überprüfung, ob es noch Fehleingaben gibt
      const hasErrors = Object.values(errors).some(error => error !== '');

      if (hasErrors) {
        // Zeige das Modal-Popup, wenn noch Fehler vorhanden sind
        setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis die Fehler behoben sind
      }

      // Fehler zurücksetzen, falls alles korrekt ist
      setErrors({});

      // Erstellen einer Kopie des Datensatzes, um ihn zu bearbeiten
      const modifiedPost = { ...post };

      // Setze leere Float- und Integer-Felder auf -123
      setDefaultForEmptyNumberFields(modifiedPost, fields);
      // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
      convertCommaToDotForFloatFields(modifiedPost, fields);

      await axios.put(`${url_root}/modify_knit_machinetype_to_id`, modifiedPost,
          {
              headers: {
                  'Authorization': `Bearer ${access_token}`
              }
          }
      );
      
      newSaveID(id); // Zeile des geänderten Datensatzes bleibt in der BasicTable markiert

      const imageName = post.filename; // Bildname ermitteln
      const institutionName = post.institution_name; 
      showImage(imageName, null, institutionName); // Bild aktualisieren
      
      fetchMachinetypes(); // Tabelle aktualisieren
            
      setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, d.h. icon wird wieder blau
      clearFields(); // Ändern-Felder leeren, da der Focus zum Kopieren der Daten neu gesetzt wird, das wäre verwirrend
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };


  // Funktion zum Kopieren des Datensatzes
  const handleButtonCopy = (id) => {    
    const copyMachinetypeData = data.find(row => row.id_machinetype === id);

    const adjustedData = { ...copyMachinetypeData }; // Eine Kopie der Daten erstellen, um sie zu bearbeiten

    // Für alle Felder im Objekt prüfen, ob der Wert 0, -123 oder null ist (Wert null ist in DB, wenn id=0)
    Object.keys(adjustedData).forEach(field => {
        if (adjustedData[field] === 0 || adjustedData[field] === -123 || adjustedData[field] === null) {
            adjustedData[field] = ''; // Wert in leeren String umwandeln
        }
    });
    setCurrentInstitutionName(copyMachinetypeData.institution_name)
    clearFields();
    setCopiedData(adjustedData); // Angepasste Daten im Zustand speichern
  };


  // Abfrage zum Löschen Datensatz als popup in extra Komponente und use Hook ausgelagert:
  const deleteApiUrl = `${url_root}/delete_knit_machinetype_to_id`;
  // benutzerdefinierter Hook useDeleteWithConfirmation kapselt die Löschlogik und den Zustand des Bestaetigungs-Popups
  const {
    isDeletePopupOpen,
    handleButtonDelete,
    handleConfirmDelete,
    closeDeletePopup,
  } = useDeleteWithConfirmation(deleteApiUrl, fetchMachinetypes, clearFields);

  
  // Funktion zum Oeffnen des Popups für das Hinzufuegen eines neuen Datensatzes
  const openNewEntryPopup = async() => {
    setClickedAnyIcon(true); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(true);
  };


  // Funktion zum Schliessen des Popups für neue Eintraege
  const closeNewPopup = () => {
    setCopiedData(null); // Setze copiedData auf null, Eingabefelder werden geleert
    setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(false);
    clearFields();
  };


  // Funktion zum Markieren des neuen Datensatzes in BasicTable
  const newSaveID = (id) => {
    setNewSelectedRowID(id) // newSelectedRowID wird auf den Wert der yarn_id gesetzt
  };
  
  
  // Daten aus anderer Tabelle
  const filteredDataManufacturer = manufacturerOptions && manufacturerOptions.knit_manufacturer ? manufacturerOptions.knit_manufacturer.filter(item => item.id_manufacturer !== 0) : [];
  const manufacturerOptionsSet = new Set(filteredDataManufacturer.map(item => item.name)); // Eindeutige Herstellerbezeichnungen erhalten
  const sortedManufacturerOptions = Array.from(manufacturerOptionsSet).sort(); // Array erstellen und aufsteigend sortieren

  const filteredDataDepartment = departmentOptions && departmentOptions.departments_to_institution ? departmentOptions.departments_to_institution.filter(item => item.id_department !== 0) : [];
  const sortedDepartmentOptions = Array.from(new Set(filteredDataDepartment.map(item => item.name)));

  const filteredDataInstitution = institutionOptions && institutionOptions.knit_institution ? institutionOptions.knit_institution.filter(item => item.id_institution !== 0) : [];
  const sortedInstitutionOptions = Array.from(new Set(filteredDataInstitution.map(item => item.name))).sort();

  const sortedPictureOptions = imageOptions.sort();
  
  const sortedDatasheetOptions = datasheetOptions.sort();

  // Daten aus knit_unit 
  const filteredDataLengthUnit = lengthUnitOptions && lengthUnitOptions.knit_unit_to_unit_type ? lengthUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedLengthUnitOptions = Array.from(new Set(filteredDataLengthUnit.map(item => item.name))).sort();

  const filteredDataDistanceUnit = distanceUnitOptions && distanceUnitOptions.knit_unit_to_unit_type ? distanceUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedDistanceUnitOptions = Array.from(new Set(filteredDataDistanceUnit.map(item => item.name))).sort();


  // Funktion zum Auffrischen des InstitutionName, wenn Admin (Rolle 1) den Institutionsnamen für neuen Datensatz im dropdown ändert
  const updateCurrentInstitutionName = async (selectedInstitutionName) => {
    setCurrentInstitutionName(selectedInstitutionName);
  }
  

  const ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg'];

  const handleDatasheetChangeAndUpload = async (event) => {
    const file = event.target.files[0]; // Die ausgewaehlte Datei
    
    if (!file) {
        alert('Keine Datei ausgewählt');
        return;
      }
      else {
        const fileExtension = file.name.split('.').pop().toLowerCase();
      
        if (!ALLOWED_EXTENSIONS.includes(fileExtension)) {
          alert('Nur Dateien der Typen png, jpg und jpeg sind erlaubt.');
          return;
        }
  
        const allowedMimeTypes = ['image/png', 'image/jpeg'];
        if (!allowedMimeTypes.includes(file.type)) {
          alert('Ungültiger Dateityp!');
          return;
        }
      }

      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'institutionName':  currentInstitutionName,
          'idInstitution': id_institution
        }
      };
    
      const response = await axios.get(`${url_root}/get_knit_id_institution_to_institution_name`, param);
      // Lokale Kopie der Parameter
      const idInstitutionLocal = response.data.id_institution;  // Stelle sicher, dass dies lokal bleibt
      const objectTypeLocal = 'machinetype';  // Spezifisch für Bilder
      // Neues FormData-Objekt erstellen
      const formData = new FormData();
      formData.append('image', file);
      formData.append('id_inst', idInstitutionLocal);
      formData.append('object_type', objectTypeLocal);
    try {
      // Datei an den Server hochladen
      await axios.post(`${url_root}/upload_datasheet`, formData, {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'Content-Type': 'multipart/form-data', // Für Datei-Upload erforderlich
        },
      });
      alert('Datei erfolgreich hochgeladen');
      
	  await fetchMachinetypeDatasheetOptions(currentInstitutionName);
	  
    } catch (error) {
      console.error('Fehler beim Hochladen der Datei:', error);
      alert('Fehler beim Hochladen der Datei');
    }
  };


  const handlePictureChangeAndUpload = async (event) => {
    const file = event.target.files[0]; // Die ausgewaehlte Datei
   
    if (!file) {
      alert('Keine Datei ausgewählt');
      return;
    }
    else {
      const fileExtension = file.name.split('.').pop().toLowerCase();
    
      if (!ALLOWED_EXTENSIONS.includes(fileExtension)) {
        alert('Nur Dateien der Typen png, jpg und jpeg sind erlaubt.');
        return;
      }

      const allowedMimeTypes = ['image/png', 'image/jpeg'];
      if (!allowedMimeTypes.includes(file.type)) {
        alert('Ungültiger Dateityp!');
        return;
      }
    }
  
    const param = {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'institutionName':  currentInstitutionName,
        'idInstitution': id_institution
      }
    };     

    const response = await axios.get(`${url_root}/get_knit_id_institution_to_institution_name`, param);      
        
    // Lokale Kopie der Parameter   
    const idInstitutionLocal = response.data.id_institution;  // Stelle sicher, dass dies lokal bleibt
    const objectTypeLocal = 'machinetype';  // Spezifisch für Bilder
        
    // Neues FormData-Objekt erstellen
    const formData = new FormData();
    formData.append('image', file);
    formData.append('id_inst', idInstitutionLocal);
    formData.append('object_type', objectTypeLocal);
    
    try {
      // Datei an den Server hochladen
      await axios.post(`${url_root}/upload_picture`, formData, {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'Content-Type': 'multipart/form-data', // Für Datei-Upload erforderlich
        },
      });
      alert('Datei erfolgreich hochgeladen');

      await fetchMachinetypeImageOptions(currentInstitutionName);

    } catch (error) {
      console.error('Fehler beim Hochladen der Datei:', error);
      alert('Fehler beim Hochladen der Datei');
    }
  };
  

  return (
    <MainLayout openNewEntryPopup={openNewEntryPopup} >
      <BasicTable 
        columns={MachinetypeColumns} 
        accessor={accessor}
        data={data} 
        handleButtonChange={handleButtonChange} 
        handleButtonCopy={handleButtonCopy}
        handleButtonDelete={handleButtonDelete}
        showDatasheet={showDatasheet}
        showImage={showImage}
        clearFields={clearFields} // Hier wird die Funktion als Prop übergeben
        newSaveID={newSelectedRowID} // Funktion zum Markieren des neuen Datensatzes in Tabelle übergeben
        fetchDepartmentOptions={fetchDepartmentOptions}
        isAnyIconClicked={clickedAnyIcon}
        showDatasheetIcon={true} // Datasheet icon wird in Tabelle angezeigt
        canCreate={can_create_machinetype}
        canUpdate={can_update_machinetype}
        canDelete={can_delete_machinetype}
        fetchMachinetypeImageOptions={fetchMachinetypeImageOptions}
        fetchMachinetypeDatasheetOptions={fetchMachinetypeDatasheetOptions}        
      />
      <div className='area-under-table'>
        {/* Nur anzeigen, wenn can_update true ist */}
        {can_update_machinetype && (
        <div className='area-change'>
          <div className='box-title'>
            <h3>Hier können Sie die Parameter ändern:</h3>
          </div>

          {fields.map(field => {
            const fieldValue = post[field.name];
            // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
            const displayValue = fieldValue < 0 ? '' : fieldValue;

          return (
            <div key={field.name} className="change-input-row"> 
              <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}
              </label>  
              
              <div className="input-with-unit">
                {field.type === 'select' ? (
                <>
                  <select 
                    onChange={handleInput} 
                    name={field.name} 
                    value={displayValue}
                    onFocus={(event) => handleFocus(event, setErrors)}
                    onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                      validateField(name, value, rules, setErrors))}
                  >
                    <option value=""></option>
                    {field.name === 'manufacturer_name' && sortedManufacturerOptions.length > 0 ? (
                      sortedManufacturerOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))
                    ) : field.name === 'department_name' ? (
                      sortedDepartmentOptions.length > 0 && sortedDepartmentOptions
                        .filter(option => option !== "")
                        .map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                    ))
                    ) : field.name === 'datasheet' ? (sortedDatasheetOptions.length > 0 && sortedDatasheetOptions.filter(
                        option => option !== "") // Filtere leere Optionen heraus
                        .map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                    ))
                    ) : field.name === 'filename' ? (sortedPictureOptions.length > 0 && sortedPictureOptions.filter(
                        option => option !== "") // Filtere leere Optionen heraus
                        .map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                    ))                  
                    ) : null}
                  </select>
                    {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
                    {errors[field.name] && (
                      <span className="error-message">{errors[field.name]}</span>
                    )}
                </>

                    ) : field.type === 'checkbox' ? (
                      <div className="change-input-row-checkbox">
                        <input 
                          type="checkbox"
                          name={field.name}
                          checked={post[field.name]}
                          onChange={handleInput}
                        />
                      </div>
                    ) : field.type === 'picture_button_group' ? ( 
                      <div className='button-group'>
                        <input
                          type="file"
                          id="fileInput6"
                          accept=".png, .jpg, .jpeg" // Erlaubt nur die angegebenen Dateitypen
                          style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                          onChange={handlePictureChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                        />
                        <button
                          type="button"
                          className="custom-button"
                          onClick={() => document.getElementById('fileInput6').click()} // Oeffnet den Datei-Dialog
                        >
                          Bild auswählen und hochladen
                        </button>
                      </div>

                    ) : field.type === 'datasheet_button_group' ? (
                      <div className='button_group'>
                        <input
                          type="file"
                          id="fileInput5"
                          accept=".png, .jpg, .jpeg" // Erlaubt nur die angegebenen Dateitypen
                          style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                          onChange={handleDatasheetChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                        />
                        <button
                          type="button"
                          className="custom-button"
                          onClick={() => document.getElementById('fileInput5').click()} // Oeffnet den Datei-Dialog
                        >
                          Datenblatt auswählen und hochladen
                        </button>
                      </div>

                    ) : field.type === 'textarea' ? (
                        <textarea className='textarea'
                          name={field.name}
                          value={displayValue}
                          onChange={handleInput}
                        />
                    ) : (
                    <>
                      <input
                        type={field.type} // Texteingabefelder
                        name={field.name}
                        value={displayValue}
                        onChange={handleInput}
                        readOnly={field.name === 'machinetype_name'}

                        onFocus={(event) => handleFocus(event, setErrors)}
                        onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                          validateField(name, value, rules, setErrors))}
                      />
                    {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}     

                    {field.unit && (      // rendern nur, wenn field.unit einen Wert hat                    
                      <select // dropdown-Menu wird gerendert, wenn ein unit (Masseinheit) vorhanden ist
                        className="unit-dropdown"
                        name={field.unit} // Verwenden Sie field.unit direkt als name
                        value={post[field.unit]} // Verwenden Sie field.unit direkt, um den Wert aus post zu erhalten
                        onChange={handleInput} // Uebergeben Sie Ihre handleInput-Funktion für onChange                 
                      >
                        <option value="" disabled> </option>                
                        {field.unit === 'unit_max_workingwidth_name' && sortedLengthUnitOptions.length > 0 ? (
                          sortedLengthUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_distance_needlebeds_name' && sortedDistanceUnitOptions.length > 0 ? (
                          sortedDistanceUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        )  : null}
                      </select>
                    )}
                    </>
                  )}
              </div>
            </div>
            );
          })}


          <div className='area-change-button'>
            <button onClick={() => clearFields()}>ABBRECHEN</button>
            <button onClick={() => handleSave(post.id_machinetype)}>SPEICHERN</button>       
          </div>
        </div> /*Ende area-change*/
      )}  

        <div className='area-image'>
          {/* Anzeigen des Bildes, wenn imageUrl vorhanden ist */}
          {imageUrl && <img src={imageUrl} alt="kein Foto vorhanden" />}
        </div> {/*Ende area-image*/}
      </div> {/*Ende area-under-table*/}
      
      {/* für popup-Datenblatt */}
      {isPopupOpen && (
          <div className="popup-overlay">
            <div className="popup-content">
              <span onClick={closePopup} className="popup-close">
                &times;
              </span>
              <img src={popupImageUrl} alt="Datenblatt" />
            </div>
          </div>
      )}

      {/* für popup NEU */}
      {isNewPopupOpen && (
        <div className="new-popup-overlay">
          <div className="new-popup-content">
            <span onClick={closeNewPopup} className="new-popup-close">
              &times;
            </span>
            <KnittingmachinetypeNew
              closeNewPopup={closeNewPopup}
              fields={fields} // Eingabefelder für neuen Datensatz
              sortedManufacturerOptions={sortedManufacturerOptions}
              sortedDepartmentOptions={sortedDepartmentOptions}
              sortedInstitutionOptions={sortedInstitutionOptions}
              sortedDatasheetOptions={sortedDatasheetOptions}
              sortedPictureOptions={sortedPictureOptions}
              updateCurrentInstitutionName={updateCurrentInstitutionName}
              sortedLengthUnitOptions={sortedLengthUnitOptions}
              sortedDistanceUnitOptions={sortedDistanceUnitOptions}
              fetchMachinetypes={fetchMachinetypes}
              fetchDepartmentOptions={fetchDepartmentOptions}
              fetchMachinetypeDatasheetOptions= {fetchMachinetypeDatasheetOptions}
              fetchMachinetypeImageOptions= {fetchMachinetypeImageOptions}
              copiedData={copiedData}
              newSaveID={newSaveID}
              formatTimestampNow={formatTimestampNow}
              setDefaultForEmptyNumberFields={setDefaultForEmptyNumberFields}
              convertCommaToDotForFloatFields={convertCommaToDotForFloatFields}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              validateField={validateField}
              setErrors={setErrors}
              errors={errors}
              setErrorMessage={setErrorMessage}
              setShowErrorModal={setShowErrorModal}
              handleDatasheetChangeAndUpload = {handleDatasheetChangeAndUpload}
              handlePictureChangeAndUpload = {handlePictureChangeAndUpload}
            />
          </div>
        </div>
      )}

      <DeleteConfirmation
        isOpen={isDeletePopupOpen}
        onClose={closeDeletePopup}
        onConfirm={handleConfirmDelete}
      />

      {/* Modal zur Fehlermeldung anzeigen, wenn showErrorModal true ist */}
      {showErrorModal && (
        <IncorrectInputModalModal
          message={errorMessage} // Dynamische Nachricht übergeben
          onClose={() => setShowErrorModal(false)} // Schließt das Modal
        />
      )}
      
    </MainLayout>
  );
}


export default KnittingmachinetypePage
